import {type ReactElement, useCallback} from 'react'

import type {ActionPropsByType, ActionType} from '../../actions/types'
import {useConfigContext} from '../../contexts'
import {BusinessModalDesktop, BusinessModalMobile} from './components/business-modal'
import {EditOrderOfPointsModal} from './components/EditOrderOfPointsModal'
import {OptimizeRouteConfirmModal} from './components/OptimizeRouteConfirmModal/OptimizeRouteConfirmModal'
import {ReturnAddressModal} from './components/ReturnAddressModal'

export function ModalAction({modal_id, ...rest}: ActionPropsByType<ActionType.MODAL>): ReactElement | null {
  const {device} = useConfigContext()

  switch (modal_id) {
    case 'select_return_point': {
      return <ReturnAddressModal {...rest} name="route.return.address" />
    }
    case 'optimize_route': {
      return <OptimizeRouteConfirmModal {...rest} />
    }
    case 'edit_order_of_points': {
      return <EditOrderOfPointsModal {...rest} />
    }
    case 'business': {
      return device === 'mobile' ? <BusinessModalMobile {...rest} /> : <BusinessModalDesktop {...rest} />
    }

    default: {
      return null
    }
  }
}

export function useToggleModalAction(setOpen: (value: boolean) => void) {
  return useCallback(() => {
    setOpen(true)
  }, [setOpen])
}
